import { render, staticRenderFns } from "./rolePermissionsAssign.view.vue?vue&type=template&id=d0dc88a2"
import script from "./rolePermissionsAssign.view.vue?vue&type=script&lang=js"
export * from "./rolePermissionsAssign.view.vue?vue&type=script&lang=js"
import style0 from "./rolePermissionsAssign.view.vue?vue&type=style&index=0&id=d0dc88a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports